import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Department, DepartmentFormPayload } from '../../types/department'

export const departmentService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
  }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<Department> | ApiSuccessResponse<Department[]>
    >('/departments', { params })
    return data
  },

  async tree(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
  }) {
    const { data } = await apiClient.get<ApiSuccessResponse<Department[]>>('/departments/tree', {
      params,
    })
    return data
  },

  async create(payload: DepartmentFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Department>>('/departments', payload)
    return data
  },

  async update(id: string, payload: DepartmentFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Department>>(`/departments/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/departments/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Department>>(`/departments/${id}/restore`)
    return data
  },
}
